import { array, nullish, pipe, string, transform } from 'valibot'
import { normalizeHtmlAttributes, normalizeLineBreaks } from './text'

/**
 * Normalize common Solr fields across different schemas.
 * This helps ensure consistent data handling and reduces redundancy.
 */

export const lastUpdatedByEditor = nullish(pipe(
  array(string()),
  transform(it => it?.[0] ?? null),
  string(),
))

export const bodytext = pipe(
  nullish(string()),
  transform((val) => {
    if (!val) {
      return ''
    }
    return normalizeHtmlAttributes(normalizeLineBreaks(val))
  }),
  string(),
)

export const author = pipe(
  nullish(array(string())),
  transform(it => it?.[0] ?? null),
  string(),
)

export const publish_date = nullish(pipe(
  array(string()),
  transform(it => it?.[0] ?? null),
  string(),
))
